<!-- Template -->

<template>
    <div v-if="visible" name="modal">
        <div
            class="modal modal-mask"
            style="display: block;"
            id="modal-edit-ticket"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-edit-ticket"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                <div class="modal-content">
                    <!-- Header -->

                    <div class="modal-header">
                        <h4 class="modal-title">Request Support</h4>
                        <button
                            @click.prevent="close"
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true" class="icon-x"></span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="notifications-container">
                            <FormNotification :message="notification" />
                            <FormNotification is-error :message="error" />
                        </div>

                        <div class="header" v-show="!ticketSent">
                            <div class="data">
                                <div class="btn-back" v-if="showBack">
                                    <a @click.prevent="back">
                                        <span class="icon-chevron-left"></span>
                                    </a>
                                </div>
                                <h2 :class="{withBackButton: showBack}"><span v-show="system.dhrNumber != ''">{{system.dhrNumber}}</span>{{system.productConfigurationDescription}}</h2>
                                <div class="clearfix"></div>
                            </div>
                        </div>

                        <ValidationObserver
                            ref="validation"
                            v-slot="{ invalid }"
                            v-show="!ticketSent"
                        >
                            <form>
                                <div class="form-group">
                                    <label for="nature-of-issue">What is the nature of the issue?</label>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            id="technical"
                                            name="nature-of-issue"
                                            class="custom-control-input"
                                            value="technical"
                                            v-model="natureOfIssue"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="technical"
                                        >Technical</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            id="clinical"
                                            name="nature-of-issue"
                                            class="custom-control-input"
                                            value="clinical"
                                            v-model="natureOfIssue"
                                        />
                                        <label class="custom-control-label" for="clinical">Clinical</label>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="system-operable">Is the system operable?</label>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            id="systemIsOperable"
                                            name="system-operable"
                                            class="custom-control-input"
                                            value="yes"
                                            v-model="systemOperable"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="systemIsOperable"
                                        >Yes</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            id="systemIsNotOperable"
                                            name="system-operable"
                                            class="custom-control-input"
                                            value="no"
                                            v-model="systemOperable"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="systemIsNotOperable"
                                        >No</label>
                                    </div>
                                </div>
                                <!-- <div class="form-group">
                                    <label for="system-operable">Preferred method of contact?</label>

                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            id="methodOfContact-email"
                                            name="method-of-contact"
                                            class="custom-control-input"
                                            value="email"
                                            v-model="methodOfContact"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="methodOfContact-email"
                                        >Email</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            id="methodOfContact-phone"
                                            name="method-of-contact"
                                            class="custom-control-input"
                                            value="phone"
                                            v-model="methodOfContact"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="methodOfContact-phone"
                                        >Phone</label>
                                    </div>
                                </div>-->

                                <!-- <div class="form-group" v-show="methodOfContact=='phone'">
                                    <label for="system-operable">Phone number</label>

                                    <div class="custom-control custom-radio custom-control-inline">
                                        <input
                                            type="radio"
                                            id="phone-number-current"
                                            name="phone-number"
                                            class="custom-control-input"
                                            value="current"
                                            v-model="phoneNumber"
                                            @click="otherPhone=''"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="phone-number-current"
                                        >+1234567890</label>
                                    </div>
                                    <div
                                        class="custom-control custom-radio custom-control-inline mr-0"
                                    >
                                        <input
                                            type="radio"
                                            id="phone-number-other"
                                            name="phone-number"
                                            class="custom-control-input"
                                            value="other"
                                            v-model="phoneNumber"
                                        />
                                        <label
                                            class="custom-control-label"
                                            for="phone-number-other"
                                        >Other</label>
                                        <ValidationProvider
                                            name="Other phone number"
                                            vid="phoneNumberOther"
                                            :rules="{ required: phoneNumber == 'other' }"
                                            v-slot="{ errors }"
                                        >
                                            <div :class="{'is-error': errors.length }">
                                                <input
                                                    type="text"
                                                    v-model="otherPhone"
                                                    class="w other-phone-input"
                                                />
                                                <div class="error-label">{{ errors[0] }}</div>
                                            </div>
                                        </ValidationProvider>
                                    </div>
                                </div>-->
                                <div class="form-group mt-5">
                                    <ValidationProvider
                                        name="Request title"
                                        vid="title"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <div :class="{'is-error': errors.length }">
                                            <label for="title">Request title</label>
                                            <input type="text" id="title" v-model="title" class="w" />
                                            <div class="error-label">{{ errors[0] }}</div>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="form-group">
                                    <ValidationProvider
                                        name="Problem description"
                                        vid="description"
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <div :class="{'is-error': errors.length }">
                                            <label for="description">Problem description</label>
                                            <textarea
                                                class="form-control"
                                                id="description"
                                                rows="3"
                                                v-model="description"
                                            ></textarea>
                                            <div class="error-label">{{ errors[0] }}</div>
                                        </div>
                                    </ValidationProvider>
                                </div>

                                <div class="submit">
                                    <div>
                                        <a href="#" class="help">Help us help you!</a>
                                        <p>
                                            Shorten the resolution time by writing
                                            <br />better problem description.
                                        </p>
                                    </div>

                                    <button
                                        type="submit"
                                        class="btn-large btn-blue"
                                        :disabled="invalid || isProcessing"
                                        @click.prevent="onSave"
                                    >
                                        <span v-if="!isProcessing">Save</span>
                                        <span v-if="isProcessing" class="spinner-border mt-0"></span>
                                    </button>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- Script -->

<script>
    import { ValidationProvider, ValidationObserver } from "vee-validate";
    import { PageMessage } from "@/models/page-message";
    import FormNotification from "@/components/Login/FormNotification";
    import { TicketService } from "@/services/ticket-service";
    import Common from '@/plugins/common';

    export default {
        name: "TicketDetails",

        components: {
            ValidationProvider,
            ValidationObserver,
            FormNotification
        },

        props: ["showBack"],

        data() {
            return {
                visible: false,
                system: null,
                isProcessing: false,
                systemOperable: "yes",
                title: "",
                description: "",
                natureOfIssue: "technical",
                //methodOfContact: "email",
                error: new PageMessage(),
                notification: new PageMessage(),
                //otherPhone: "",
                //phoneNumber: "current",
                ticketSent: false
            };
        },

        created() {
            this.ticketService = new TicketService(this.$api, this.$store);
        },

        computed: {
            validator() {
                return this.$refs.validation;
            }
        },

        methods: {
            resetForm() {
                this.systemOperable = "yes";
                this.title = "";
                this.description = "";
                this.natureOfIssue = "technical";
                this.error.reset();
                this.notification.reset();
                this.isProcessing = false;
                this.ticketSent = false;
                //this.methodOfContact = "email";
                //this.otherPhone = "";
                //this.phoneNumber = "current";
            },

            show(system) {
                this.resetForm();
                this.system = system;
                this.visible = true;
            },

            close() {
                this.resetForm();
                this.visible = false;
            },

            back() {
                this.resetForm();
                this.close();
                this.$emit("back");
            },

            async onSave() {
                this.isProcessing = true;
                this.error.reset();
                this.notification.reset();

                const isValid = await this.validator.validate();
                if (!isValid) return;

                var self = this;
                try {
                    var data = {
                        siteID:
                            this.system.siteID == undefined
                                ? this.system.siteId
                                : this.system.siteID,
                        supportTicketNatureId: this.natureOfIssue == "technical" ? 1 : 2,
                        description: this.description,
                        shortSummary: this.title,
                        systemID: this.system.id,
                        systemOperable: this.systemOperable == "yes" ? true : false,
                    };

                    

                    var response = await this.ticketService.createTicket(data);

                    

                    /*var messagePhone =
                            "You entered a phone number that is different to what our records hold.<br>The new phone number will be saved for this ticket only.<br>If you wish to change your phone number for all future tickets, please do so via your contact page.";
                        */
                    var messageTicket =
                        "Thank you for creating a support request.<br>Your request’s reference is #"+response.id+".";

                    /*if (self.otherPhone != "") {
                            self.notification.set(
                                messageTicket + "<br><br>" + messagePhone
                            );
                        } else {
                            self.notification.set(messageTicket);
                        }
                        */


                    var newTicketData = {
                        data: data,
                        response: response,
                        user: {
                            id:this.$store.getters['session/get'].nameID,
                            name: ''
                        },
                        system: this.system
                    }

                    var sites = this.$store.getters['hospital/sites'];
                    
                    if(sites && sites.length > 0){
                        (function() { 
                            for(var i = 0; i < sites.length; i++){
                                for(var j = 0; j < sites[i].contacts.length; j++){
                                    if(sites[i].contacts[j].id == self.$store.getters['session/get'].nameID){
                                        newTicketData.user.name = sites[i].contacts[j].firstName + ' ' + sites[i].contacts[j].lastName;
                                        return;
                                    }
                                }
                            }
                        })();
                    }

                    var storeData = Common.parseNewTicketData(newTicketData);

                    this.$store.dispatch('hospital/updateTickets', storeData); 
                    this.$store.dispatch('system/updateTickets', storeData);  

                    self.notification.set(messageTicket);
                    this.isProcessing = true;
                    this.ticketSent = true;
                } catch (error) {
                    this.error.setError(error.data.title);
                } finally {
                    this.isProcessing = false;
                }
            }
        }
    };
</script>

